import { HubPage } from "../../components/ui/kaizen/HubPage";
import { HUB_META } from "../../lib/legacyRoutes";
import { PaintBrush, Megaphone, Flag, Money, CreditCard, Receipt, ChartLineUp, CalendarDots, Tag, Robot, ChatCircleText, Storefront, Ticket, DownloadSimple, BookOpen } from "@phosphor-icons/react";

import ContentStudioModule from "../ContentStudioModule";
import ImpactStudioModule from "../ImpactStudioModule";
import StudioIAModule from "../StudioIAModule";
import GenerateurAffichesModule from "../GenerateurAffichesModule";
import KaizenLogosGallery from "../KaizenLogosGallery";
import MarketingModule from "../MarketingModule";
import MarketingStudioModule from "../MarketingStudioModule";
import MarketingAutopilotModule from "../MarketingAutopilotModule";
import FacebookPagesModule from "../FacebookPagesModule";
import TikTokConnectModule from "../TikTokConnectModule";
import StudioPipelineModule from "../StudioPipelineModule";
import PlanificateurAnnuelModule from "../PlanificateurAnnuelModule";
import CampagneLes3Module from "../CampagneLes3Module";
import MarketingPlan30Module from "../MarketingPlan30Module";
import MarketingDashboardModule from "../MarketingDashboardModule";
import MarketingAIModule from "../MarketingAIModule";
import MemberPaymentsModule from "../MemberPaymentsModule";
import ContratsPaiementsModule from "../ContratsPaiementsModule";
import FacturesImpayeesModule from "../FacturesImpayeesModule";
import RelancesImpayesModule from "../RelancesImpayesModule";
import RecoveryModule from "../RecoveryModule";
import CreditMonitor from "../CreditMonitor";
import StripeManagerModule from "../StripeManagerModule";
import StripeReconcileModule from "../StripeReconcileModule";
import OnlineRevenueDashboard from "../OnlineRevenueDashboard";
import ReconciliationModule from "../ReconciliationModule";
import BookkeepingModule from "../BookkeepingModule";
import ComptabiliteKaizenModule from "../ComptabiliteKaizenModule";
import FacturationModule from "../FacturationModule";
import RapprochementTPSTVQ from "../RapprochementTPSTVQ";
import SeparationRevenus from "../SeparationRevenus";
import QuickBooksModule from "../QuickBooksModule";
import FinanceModule from "../FinanceModule";
import PnLLiveModule from "../PnLLiveModule";
import RevenuePlanModule from "../RevenuePlanModule";
import ObjectifsMoisModule from "../ObjectifsMoisModule";
import HoraireAdminModule from "../HoraireAdminModule";
import HoraireEteModule from "../HoraireEteModule";
import EventsModule from "../EventsModule";
import CalendrierAnnuelModule from "../CalendrierAnnuelModule";
import SpecialDaysModule from "../SpecialDaysModule";
import AgendaModule from "../AgendaModule";
import DojoTariffsModule from "../DojoTariffsModule";
import PricingCarnetsModule from "../PricingCarnetsModule";
import ConformiteTarifsModule from "../ConformiteTarifsModule";
import OperatorModule from "../OperatorModule";
import WingmanDashboard from "../WingmanDashboard";
import WingmanTriage from "../WingmanTriage";
import CamilleEmailModule from "../CamilleEmailModule";
import KaizenMemoryAdmin from "../KaizenMemoryAdmin";
import RechercheVeilleModule from "../RechercheVeilleModule";
import ProjectsModule from "../ProjectsModule";
import EmailsModule from "../EmailsModule";
import MemberEmailBroadcastModule from "../MemberEmailBroadcastModule";
import SmsBroadcastModule from "../SmsBroadcastModule";
import AnnoncesModule from "../AnnoncesModule";
import CommTemplatesModule from "../CommTemplatesModule";
import CourrielsEnvoyes from "../CourrielsEnvoyes";
import BoutiqueAdminModule from "../BoutiqueAdminModule";
import PrintfulModule from "../PrintfulModule";
import BoutiqueProduitsModule from "../BoutiqueProduitsModule";
import GiftCardAdminModule from "../GiftCardAdminModule";
import PromoManagerModule from "../PromoManagerModule";
import PromoKitDashboard from "../PromoKitDashboard";
import PromotionsRadarModule from "../PromotionsRadarModule";
import ContactsBulkModule from "../ContactsBulkModule";
import ZenPlannerImport from "../ZenPlannerImport";
import CancelledMigrationModule from "../CancelledMigrationModule";
import ZenPlannerMigrationModule from "../ZenPlannerMigrationModule";
import BulkEditElevesModule from "../BulkEditElevesModule";
import GuideModule from "../GuideModule";
import GuideCoachModule from "../GuideCoachModule";
import RencontreCoachsModule from "../RencontreCoachsModule";
import ReceptionModule from "../ReceptionModule";

const GuideReception = () => <ReceptionModule guide />;

// Composant par onglet, indexé par ancienne URL (source unique : HUB_META).
const COMPONENTS = {
  "/app/studio-contenu": ContentStudioModule, "/app/impact-studio": ImpactStudioModule, "/app/studio-ia": StudioIAModule, "/app/generateur-affiches": GenerateurAffichesModule, "/app/logos": KaizenLogosGallery,
  "/app/marketing": MarketingModule, "/app/marketing-studio": MarketingStudioModule, "/app/pilote-reseaux": MarketingAutopilotModule, "/app/facebook": FacebookPagesModule, "/app/tiktok": TikTokConnectModule, "/app/studio": StudioPipelineModule,
  "/app/planificateur-annuel": PlanificateurAnnuelModule, "/app/campagne-les3": CampagneLes3Module, "/app/marketing-plan30": MarketingPlan30Module, "/app/marketing-dashboard": MarketingDashboardModule, "/app/marketing-ai": MarketingAIModule,
  "/app/membres-paiements": MemberPaymentsModule, "/app/contrats-paiements": ContratsPaiementsModule, "/app/factures-impayees": FacturesImpayeesModule, "/app/relances-impayes": RelancesImpayesModule, "/app/recouvrement": RecoveryModule, "/app/credit": CreditMonitor,
  "/app/stripe-manager": StripeManagerModule, "/app/stripe-rapprochement": StripeReconcileModule, "/app/revenus-en-ligne": OnlineRevenueDashboard, "/app/reconciliation": ReconciliationModule,
  "/app/comptabilite": BookkeepingModule, "/app/comptabilite-kaizen": ComptabiliteKaizenModule, "/app/facturation": FacturationModule, "/app/rapprochement-tps-tvq": RapprochementTPSTVQ, "/app/separation-revenus": SeparationRevenus, "/app/quickbooks": QuickBooksModule,
  "/app/finances": FinanceModule, "/app/pnl": PnLLiveModule, "/app/revenue-plan": RevenuePlanModule, "/app/objectifs-mois": ObjectifsMoisModule,
  "/app/horaire": HoraireAdminModule, "/app/horaire-ete": HoraireEteModule, "/app/evenements": EventsModule, "/app/calendrier-annuel": CalendrierAnnuelModule, "/app/calendrier-kaizen": SpecialDaysModule, "/app/agenda": AgendaModule,
  "/app/inscriptions-dojo": DojoTariffsModule, "/app/tarifs": PricingCarnetsModule, "/app/conformite": ConformiteTarifsModule,
  "/app/operator": OperatorModule, "/app/wingman": WingmanDashboard, "/app/wingman-gmail": WingmanTriage, "/app/camille": CamilleEmailModule, "/app/memoire": KaizenMemoryAdmin, "/app/recherche": RechercheVeilleModule, "/app/dossiers": ProjectsModule, "/app/courriels": EmailsModule,
  "/app/diffusion-courriel": MemberEmailBroadcastModule, "/app/diffusion-sms": SmsBroadcastModule, "/app/annonces": AnnoncesModule, "/app/comm-templates": CommTemplatesModule, "/app/courriels-envoyes": CourrielsEnvoyes,
  "/app/boutique-admin": BoutiqueAdminModule, "/app/printful": PrintfulModule, "/app/boutique-produits": BoutiqueProduitsModule, "/app/cartes-cadeaux": GiftCardAdminModule,
  "/app/promos": PromoManagerModule, "/app/promos-kit": PromoKitDashboard, "/app/promotions": PromotionsRadarModule,
  "/app/contacts-bulk": ContactsBulkModule, "/app/import-membres": ZenPlannerImport, "/app/migration-annules": CancelledMigrationModule, "/app/zp-migration": ZenPlannerMigrationModule, "/app/bulk-edit-eleves": BulkEditElevesModule,
  "/app/guide": GuideModule, "/app/guide-coach": GuideCoachModule, "/app/rencontre-coachs": RencontreCoachsModule, "/app/guide-reception": GuideReception,
};

const ICONS = {
  "/app/studio-creatif": PaintBrush, "/app/publications": Megaphone, "/app/campagnes": Flag, "/app/encaissements": Money, "/app/stripe": CreditCard,
  "/app/comptabilite-taxes": Receipt, "/app/pilotage-financier": ChartLineUp, "/app/calendrier": CalendarDots, "/app/grille-tarifaire": Tag, "/app/assistants-ia": Robot,
  "/app/communications": ChatCircleText, "/app/boutique": Storefront, "/app/offres": Ticket, "/app/imports": DownloadSimple, "/app/guides": BookOpen,
};
const FLOWS = {
  "/app/studio-creatif": "Communiquer", "/app/publications": "Communiquer", "/app/campagnes": "Communiquer", "/app/communications": "Communiquer",
  "/app/encaissements": "Encaisser", "/app/stripe": "Encaisser", "/app/boutique": "Encaisser", "/app/offres": "Encaisser", "/app/grille-tarifaire": "Encaisser",
  "/app/comptabilite-taxes": "Comptabiliser", "/app/pilotage-financier": "Comptabiliser", "/app/assistants-ia": "Comptabiliser", "/app/imports": "Inscrire",
  "/app/calendrier": "Enseigner", "/app/guides": "Enseigner",
};

export const HUB_ICONS = ICONS;

// { "/app/studio-creatif": <Composant hub />, ... }
export const HUB_PAGES = Object.fromEntries(Object.entries(HUB_META).map(([path, meta]) => {
  const tabs = meta.tabs.map((t) => ({ ...t, component: COMPONENTS[t.legacy] }));
  const Page = () => <HubPage path={path} title={meta.title} desc={meta.desc} flow={FLOWS[path]} icon={ICONS[path]} tabs={tabs} />;
  Page.displayName = `Hub(${meta.title})`;
  return [path, Page];
}));
